import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  Card,
  CardMedia,
  Dialog,
  DialogContent,
  DialogTitle,
  Tab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import axios from "axios";
import { coreNodeFileURL } from "../constants";

export default function ViewRxDialog({
  viewRxDialogVisible,
  orderId,
  patientName,
  setViewRxDialogVisibility,
  uploadedFiles,
}) {
  const extractUUID = (url) => {
    // Split by '/' and get the last part
    const parts = url.split("/");
    return parts[parts.length - 1];
  };
  const [tabValue, setTabValue] = useState("0");
  const [fileType, setFileType] = useState("pdf");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  
  useEffect(() => {
    if (uploadedFiles && uploadedFiles.length > 0) {
      const url = `${coreNodeFileURL}/${extractUUID(
        uploadedFiles[tabValue]
      )}?preview=true`;
      
      axios.get(url, { responseType: 'blob' })
        .then((res) => {
          const contentType = res.headers['content-type'];
          if (contentType && contentType.includes('pdf')) {
            setFileType('pdf');
          } else if (contentType && contentType.includes('image')) {
            setFileType('image');
          } else {
            setFileType('other');
          }
        })
        .catch((error) => {
          console.error("Error fetching file:", error);
          setFileType('other');
        });
    }
  }, [uploadedFiles, tabValue]);

  return (
    <Dialog
      open={viewRxDialogVisible}
      onClose={() => setViewRxDialogVisibility(false)}
      fullWidth={true}
      maxWidth={"lg"}
    >
      <DialogTitle style={{ background: "rgb(245 245 245)" }}>
        <div className="flex justify-between">
          <div className="font-semibold">
            <span className="cursor-pointer">View Prescription</span>
            <div className="text-xs text-gray-500">
              Order ID: <span className="font-semibold">{orderId} </span>
            </div>
            <div className="text-xs text-gray-500">
              Patient Name:
              <span className="font-semibold">{patientName} </span>
            </div>
          </div>
          <div
            className="text-gray-500"
            onClick={() => setViewRxDialogVisibility(false)}
          >
            <span className="cursor-pointer">
              <CloseIcon></CloseIcon>
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange} aria-label="prescription tabs">
                {uploadedFiles?.map((item, index) => (
                  <Tab key={index} label={`Prescription ${index + 1}`} value={index.toString()} />
                ))}
              </TabList>
            </Box>
            {uploadedFiles?.map((item, index) => (
              <TabPanel key={index} value={index.toString()}>
                <Card sx={{ maxWidth: "100%" }}>
                  {fileType === "pdf" ? (
                    <CardMedia
                      component="iframe"
                      sx={{ 
                        height: { xs: 350, sm: 400, md: 450 },
                        width: '100%',
                      }}
                      src={`${coreNodeFileURL}/${extractUUID(
                        item
                      )}?preview=true`}
                    />
                  ) : (
                    <Box
                      p={'2px'}
                      sx={{
                        minHeight: '500px',
                        maxHeight: '500px',
                        overflowY: 'scroll',
                        cursor: 'pointer',
                        visible: !fileType !== "pdf"
                      }}
                    >
                      <img
                        src={`${coreNodeFileURL}/${extractUUID(item)}?preview=true`}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </Box>
                  )}
                </Card>
              </TabPanel>
            ))}
          </TabContext>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
